import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { ITransitionApplyAllFeature } from '@framework/workbench/ui/transition/transition-apply-all/transition-apply-all-interface';

@Feature()
export class TransitionApplyAllFeature extends BaseToolbarFeature implements ITransitionApplyAllFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleApply() {
        this.transitionService?.promise().then((module) => {
            module.applyTransitionToAll();
        });
    }

    private get transitionService() {
        return this.getAppService().editableServiceLayer?.transitionService;
    }
}
